import store from './store';
var currentLanguage = store.get('language', 'local');
var cbrConfig = {
    hosts: {
        apigee: new URL('https://api-uat.syf.com'),
        assets: new URL('https://qa.synchronycredit.com')
    },
    apiErrorCallback: function () { return undefined; },
    lang: currentLanguage
};
export default cbrConfig;
